const MESSAGE_SOURCE = "ameelio-isolated-call";

export type IframeMessageType = {
  USER_UNAUTHORIZED: undefined;
  CALL_ENDED: { callId: string; reason?: string };
  USER_LEFT: { callId: string; userId: string };
  USER_JOINED: { callId: string; userId: string };
};

export interface IframeMessage<T> {
  source: typeof MESSAGE_SOURCE;
  type: keyof IframeMessageType;
  payload?: T;
}

export function sendToParent<T extends keyof IframeMessageType>(
  type: T,
  payload?: IframeMessageType[T]
) {
  // In case we're not in an iframe...
  if (window.parent === window) return;

  const message: IframeMessage<IframeMessageType[T]> = {
    source: MESSAGE_SOURCE,
    type,
    payload,
  };

  window.parent.postMessage(message, "*");
}
